import { StandardEvents } from "@shopify/events";
//#region assets/vp-direct-checkout.ts
/**
* Design-system "Direct afrekenen": add current product to cart, then go to Shopify checkout.
* Avoids Shopify accelerated checkout (Google Pay / Apple Pay / Shop Pay) widgets.
*/
var FLAG = "vpDirectCheckoutPending";
/** @type {HTMLFormElement | null} */
var pendingForm = null;
/** @type {HTMLButtonElement | null} */
var pendingAddButton = null;
var listenersBound = false;
function bindGlobalListeners() {
	if (listenersBound) return;
	listenersBound = true;
	document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
		if (!window[FLAG]) return;
		if (event.action && event.action !== "add") return;
		const finish = (didError) => {
			if (!window[FLAG]) return;
			window[FLAG] = false;
			const addButton = pendingAddButton;
			const form = pendingForm;
			pendingAddButton = null;
			pendingForm = null;
			if (addButton instanceof HTMLButtonElement) addButton.dataset.puppet = "false";
			if (didError || !(form instanceof HTMLFormElement)) return;
			form.submit();
		};
		if (event.promise instanceof Promise) event.promise.then((result) => finish(Boolean(result?.detail?.didError))).catch(() => finish(true));
		else finish(false);
	});
	document.addEventListener(StandardEvents.cartError, () => {
		if (!window[FLAG]) return;
		window[FLAG] = false;
		if (pendingAddButton instanceof HTMLButtonElement) pendingAddButton.dataset.puppet = "false";
		pendingAddButton = null;
		pendingForm = null;
	});
}
/**
* @param {HTMLElement} root
*/
function bindDirectCheckout(root) {
	const button = root.querySelector("[data-vp-direct-checkout]");
	const form = root.querySelector("[data-vp-direct-checkout-form]");
	const addButton = root.querySelector("[ref=\"addToCartButton\"]");
	if (!(button instanceof HTMLButtonElement) || !(form instanceof HTMLFormElement)) return;
	if (button.dataset.vpDirectCheckoutBound === "true") return;
	button.dataset.vpDirectCheckoutBound = "true";
	button.addEventListener("click", (event) => {
		event.preventDefault();
		if (button.disabled) return;
		if (window[FLAG]) return;
		window[FLAG] = true;
		pendingForm = form;
		pendingAddButton = addButton instanceof HTMLButtonElement ? addButton : null;
		if (addButton instanceof HTMLButtonElement && !addButton.disabled) {
			addButton.dataset.puppet = "true";
			addButton.click();
			return;
		}
		const productForm = root.querySelector("form.product-details__form, form[action*=\"/cart/add\"]");
		if (productForm instanceof HTMLFormElement) {
			productForm.requestSubmit?.(addButton instanceof HTMLButtonElement ? addButton : void 0);
			return;
		}
		window[FLAG] = false;
		pendingForm = null;
		pendingAddButton = null;
	});
}
function init() {
	bindGlobalListeners();
	document.querySelectorAll("product-form-component, sticky-add-to-cart").forEach((root) => {
		if (root instanceof HTMLElement) bindDirectCheckout(root);
	});
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
else init();
//#endregion
